import { useAuthInfo, useRedirectFunctions } from '@propelauth/react';
import { useGlobalStore } from '../store/GlobalStore';
import { useEffect } from 'react';
import { FusawareUser } from '../fusawareUser';

export function useAuthSync() {
  const authInfo = useAuthInfo();
  const { redirectToLoginPage } = useRedirectFunctions();
  const { setAccessToken, setUserClass, setRedirectToLogin } = useGlobalStore.getState();

  useEffect(() => {
    setRedirectToLogin(() => {
      redirectToLoginPage({ postLoginRedirectUrl: window.location.href });
    });
  }, [redirectToLoginPage, setRedirectToLogin]);

  useEffect(() => {
    if (authInfo?.accessToken) {
      setAccessToken(authInfo.accessToken);
      setUserClass(new FusawareUser(authInfo.userClass));
    }
  }, [authInfo?.accessToken, setAccessToken, setUserClass]);
}
